import {SerializedStyles} from '@emotion/react';
import {css, InputAdornment, TextField, TextFieldProps, useTheme} from '@mui/material';
import {isEmpty, isNumber} from 'lodash';
import React, {ReactNode} from 'react';
import {useIntl} from 'react-intl';
// import ClearIcon from 'src/assets/icons/clearIcon.svg';
import {utils} from 'src/js/common';
// import {getIconComponentByName} from 'src/js/common/icons/icon_helpers';
import {GetStylesFunction} from 'src/js/common/types';

import {DlMuiDynamicIcon} from './DlMuiDynamicIcon';

interface OwnProps {
  inputCss?: SerializedStyles;
  label: string | ReactNode;
  searchPrefix?: string;
  iconName?: string;
  isDefaultValue?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

type Props = OwnProps & TextFieldProps;

export const DlMuiTextField: React.FC<Props> = (props) => {
  const {inputCss, label, searchPrefix, iconName, value, isDefaultValue, onChange, InputLabelProps, InputProps, disabled, ...restProps} =
    props;
  const theme = useTheme();
  let isOccupied = !isDefaultValue;
  if (isDefaultValue === undefined) isOccupied = isNumber(value) || (!isEmpty(value) && value !== '');
  const styles = getStyles({theme, params: {inputCss}});
  const intl = useIntl();

  const clearFilterTranslatedMessage = utils.TranslateUtils.translate('filter.remove', intl);

  return (
    <TextField
      data-name={'dl-mui-text-field--text-field'}
      data-occupied={isOccupied}
      data-disabled={Boolean(disabled)}
      disabled={disabled}
      {...restProps}
      label={label}
      value={value}
      InputLabelProps={{
        ...InputLabelProps,
        ...(label ? {} : {shrink: false}),
      }}
      InputProps={{
        ...InputProps,
        ...(searchPrefix
          ? {
              startAdornment: <InputAdornment position={'start'}>{searchPrefix}</InputAdornment>,
            }
          : {}),
        ...(iconName
          ? {
              endAdornment: (
                <InputAdornment position={'end'}>
                  {isOccupied ? (
                    <DlMuiDynamicIcon
                      iconName={'clearIcon'}
                      inputCss={styles.iconWrapper}
                      svgIconInputCss={styles.icon}
                      onClick={onChange as any}
                      iconTitle={isOccupied ? clearFilterTranslatedMessage : ''}
                      noButtonStyles
                    />
                  ) : (
                    <DlMuiDynamicIcon
                      iconName={iconName}
                      inputCss={styles.iconWrapper}
                      svgIconInputCss={styles.icon}
                      iconTitle={''}
                      noButtonStyles
                    />
                  )}
                </InputAdornment>
              ),
            }
          : {}),
      }}
      onChange={onChange}
      css={styles.textField}
    />
  );
};

DlMuiTextField.displayName = 'DlMuiTextField';

const getStyles: GetStylesFunction = (options) => {
  return {
    textField: css({}, options?.params?.inputCss),
    icon: css`
      cursor: pointer;
      width: 16px;
      height: 16px;
    `,
    iconWrapper: css`
      padding: 0;
    `,
  };
};
